module.exports = __webpack_public_path__ + "img/25.7054962f.png";